import * as React from 'react';
import { useTimestampStyles_unstable } from './useTimestampStyles.styles';
import type { TimestampProps } from './Timestamp.types';
import type { TextProps } from '@fluentui/react-components';
import { useText_unstable, type ForwardRefComponent, renderText_unstable } from '@fluentui/react-components';

// Timestamp component - TODO: add more docs
export const Timestamp: ForwardRefComponent<TimestampProps> = React.forwardRef((props, ref) => {
  const state = useText_unstable({ as: 'h4', ...props } as TextProps, ref);

  useTimestampStyles_unstable(state);

  return renderText_unstable(state);
});

Timestamp.displayName = 'Timestamp';
